export default __webpack_public_path__ + "images/e112cda586a8dd9f10334e6feb214066-latin_music_small.webp";